<div class="announcement-main">

  <div class="announcement-header">

    <h1>{{ title }}</h1>

    <h2>{{ createUser }}</h2>

    <label>{{ startDate | date: "yyyy/MM/dd" }} ~ {{ endDate | date: "yyyy/MM/dd" }}</label>
    <br>
    <div class="announcement-category mb-3">
      <label class="announcement-receiver-label">{{ type | optionsMapping: announcementTypeOptions}}</label> &nbsp;
    </div>

    <span *ngFor="let file of fileList" class="announcement-link">
      <div *ngIf="file.docId then fileFormat else noFileFormat"></div>
        <ng-template #fileFormat >
          <i class="fas fa-paperclip"></i>
          <a class="moust-pointer" (click)="downloadAnnouncementFile(file.docId,file.name,file.type)" >
            <span class="mr-2">{{ file.name }}.{{ file.type }}</span>
          </a>
        </ng-template>

        <ng-template #noFileFormat>
          <i class="fas fa-paperclip"></i>
          {{ file.name }}.{{ file.type }}
        </ng-template>
    </span>

  </div>
  <div class="announcement-dashed"></div>
  <div class="announcement-content" [innerHTML]="content | safeHtml"></div>
  <div class="announcement-bottom">&nbsp;</div>
</div>

